import { render, staticRenderFns } from "./mobile-header.vue?vue&type=template&id=060965be&scoped=true"
import script from "./mobile-header.vue?vue&type=script&lang=ts"
export * from "./mobile-header.vue?vue&type=script&lang=ts"
import style0 from "./mobile-header.vue?vue&type=style&index=0&id=060965be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060965be",
  null
  
)

export default component.exports